import { useEffect, useReducer } from 'react';
import { messageService } from '@/core/messaging/export';
import { getInAppTopic } from '@/core/notifications/services/in-app-topic-service';

export default function useNotificationSubscription<T>(
  callback: (message: T, headers: { [key: string]: string }) => void,
) {
  interface Delivery {
    message: T;
    headers: { [key: string]: string };
  }
  interface State {
    count: number;
  }

  const [, dispatch] = useReducer(
    (state: State, message: Delivery): State => {
      callback(message.message, message.headers);
      return { count: state.count + 1 };
    },
    { count: 0 },
    arg => arg,
  );

  useEffect(() => {
    let cancelled = false;
    let subscription: ReturnType<typeof messageService.subscribe> | undefined;

    getInAppTopic().then(topic => {
      if (cancelled) return;
      if (!topic) {
        console.warn('No in-app topic available, skipping in-app notifications subscription');
        return;
      }
      subscription = messageService.subscribe<T>(topic, (message, headers) => {
        dispatch({ message, headers });
      });
    });

    return () => {
      cancelled = true;
      subscription?.unsubscribe();
    };
  }, []);
}
